export enum SourceDisplayOnEnum {

    ThisPage = 1,

    AllPages = 2,

}
